import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import React from "react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useDispatch } from "react-redux";
import { changePassword } from "../actions/profileAction";
const formSchema = z
  .object({
    OldPassword: z.any(),
    NewPassword: z.any(),
    ConfirmPassword: z.any(),
  })
  .refine((data) => data.NewPassword === data.ConfirmPassword, {
    message: "Passwords don't match",
    path: ["ConfirmPassword"],
  });

const ChangePassword = () => {
  const dispatch = useDispatch();
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      OldPassword: "",
      NewPassword: "",
      ConfirmPassword: "",
    },
  });
  const { reset } = useForm();
  const onSubmit = (obj) => {
    dispatch(
      changePassword(obj, (isSuccess) => {
        if (isSuccess) {
          form.setValue("OldPassword", "");
          form.setValue("NewPassword", "");
          form.setValue("ConfirmPassword", "");
        }
      })
    );
  };
  return (
    <div className="py-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="mb-4">
          <h2 className="text-2xl font-semibold leading-none tracking-tight mb-2">
            Change Pasword
          </h2>
          <p className="text-sm text-muted-foreground">
            Update your password associated with your account.
          </p>
        </div>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="col-span-2">
              <div className="mb-4">
                <FormField
                  control={form.control}
                  name="OldPassword"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Current Password </FormLabel>
                      <FormControl>
                        <Input {...field} />
                      </FormControl>
                      <FormDescription />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
              <div className="mb-4">
                <FormField
                  control={form.control}
                  name="NewPassword"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>New Password </FormLabel>
                      <FormControl>
                        <Input {...field} />
                      </FormControl>
                      <FormDescription />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
              <div className="mb-4">
                <FormField
                  control={form.control}
                  name="ConfirmPassword"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Confirm Password</FormLabel>
                      <FormControl>
                        <Input {...field} />
                      </FormControl>
                      <FormDescription />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>

              <div className="flex">
                <Button type="submit" size="sm">
                  Save Changes
                </Button>
              </div>
            </div>
          </form>
        </Form>
      </div>
    </div>
  );
};

export default ChangePassword;
